import { renderLucideIcon } from '../utils/lucide-icons.js'
import { renderMessageText } from './message-text-renderer.js'

function normalizeCustomAgentResponseUi(result) {
  var rendering = result && result.stepResult && result.stepResult.rendering
  if (rendering && rendering.status !== 'published') return null
  var data = result && result.stepResult && result.stepResult.data
  if (!data || typeof data !== 'object' || !data.agentId || typeof data.reply !== 'string') return null
  return {
    reply: data.reply,
    citations: Array.isArray(data.citations) ? data.citations.filter(Boolean) : [],
    contradictions: Array.isArray(data.contradictions) ? data.contradictions.filter(Boolean) : [],
    followUps: Array.isArray(data.followUps)
      ? data.followUps.filter(function (item) { return item && item.label && item.targetAgentKey }).slice(0, 3).map(function (item, index) {
          return {
            index: index,
            label: String(item.label),
            targetCapability: String(item.targetAgentKey),
            reason: String(item.reason || ''),
            requestContext: {
              capabilitySuggestion: {
                targetCapability: String(item.targetAgentKey),
                label: String(item.label),
                reason: String(item.reason || '')
              }
            }
          }
        })
      : []
  }
}

function renderCustomAgentResponseUi(ui) {
  if (!ui) return ''
  var citations = ui.citations || []
  var contradictions = ui.contradictions || []
  var citationById = new Map(citations.map(function (citation) { return [String(citation.citationId || citation.id), citation] }))
  var contradictionHtml = contradictions.length
    ? '<aside class="wc-custom-agent-contradictions" role="alert"><div class="wc-custom-agent-evidence-title">' + renderLucideIcon('triangleAlert', { size: 16 }) + '<strong>Sources contradictoires</strong></div>' + contradictions.map(function (item) {
        var refs = (item.citationIds || []).map(function (id) { return citationById.get(String(id)) }).filter(Boolean)
        return '<div class="wc-custom-agent-contradiction"><p>' + escapeHtml(item.summary) + '</p>' + renderCitationList(refs) + '</div>'
      }).join('') + '</aside>'
    : ''
  var followUpHtml = ui.followUps && ui.followUps.length
    ? '<section class="wc-custom-agent-followups" aria-label="Suites proposées"><strong>Pour aller plus loin</strong><div class="wc-custom-agent-followup-list">' + ui.followUps.map(function (action) {
        return '<button type="button" class="capability-action wc-custom-agent-followup" data-custom-agent-followup-index="' + escapeHtml(action.index) + '">' + renderLucideIcon('arrowRight', { size: 18 }) + '<span>' + escapeHtml(action.label) + '</span></button>'
      }).join('') + '</div></section>'
    : ''
  return '<div class="wc-custom-agent-response"><div class="wc-custom-agent-reply">' + renderMessageText(ui.reply) + '</div>' + contradictionHtml + renderCitationList(citations) + followUpHtml + '</div>'
}

function bindCustomAgentResponseActions(root, ui, onAction) {
  if (!root || !ui || typeof onAction !== 'function') return
  root.querySelectorAll('[data-custom-agent-followup-index]').forEach(function (button) {
    button.addEventListener('click', function () {
      var action = (ui.followUps || [])[Number(button.getAttribute('data-custom-agent-followup-index'))]
      if (action) onAction(action)
    })
  })
}

function renderCitationList(citations) {
  if (!citations || !citations.length) return ''
  return '<section class="wc-custom-agent-citations" aria-label="Sources utilisées"><div class="wc-custom-agent-evidence-title">' + renderLucideIcon('bookOpen', { size: 16 }) + '<strong>Sources utilisées</strong></div>' + citations.map(function (citation) {
    var page = citation.page ? ' · page ' + escapeHtml(citation.page) : ''
    return '<details class="wc-custom-agent-citation"><summary>' + escapeHtml(citation.title || 'Source') + page + '</summary><p>' + escapeHtml(citation.excerpt || '') + '</p></details>'
  }).join('') + '</section>'
}

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export { normalizeCustomAgentResponseUi, renderCustomAgentResponseUi, bindCustomAgentResponseActions }
